import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Ows from "../../utils/OwsHandler";

interface RelationState {
  relation: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: RelationState = {
  relation: null,
  loading: false,
  error: null,
};

export const fetchRelation = createAsyncThunk(
  "relationo/fetchRelation", 
  async (uid: string, { rejectWithValue }) => {
  try {
    const { response } = await Ows.handleRequest("Otys.Services.RelationService.getDetail", [
      uid,
      {
        uid: true,
        status: true,
        relation: true,
        email: true,
        Addresses: true,
        phoneNumberMain: true,
        profileImage: true,
      },
    ]);

    if (response) {
      return response;
    } else {
      return rejectWithValue("No relation found with this email.");
    }
  } catch (error: any) {
    return rejectWithValue("Failed to fetch relation.");
  }
});

const relationeSlice = createSlice({
  name: "relation",
  initialState,
  reducers: {
    resetRelation: (state) => {
      state.relation = null;
      state.loading = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRelation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRelation.fulfilled, (state, action) => {
        state.relation = action.payload;
        state.loading = false;
      })
      .addCase(fetchRelation.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export const { resetRelation, clearError } = relationeSlice.actions;
export default relationeSlice.reducer;
